import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.bereich-rolle-hinzufuegen-multi';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichRolleHinzufuegenMultiEffects {

    BereichRolleHinzufuegenMulti$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BEREICH_ROLLE_HINZUFUEGEN_MULTI),
        mergeMap((x: ac.PostBereichRolleHinzufuegenMultiAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBereichRolleHinzufuegenMulti(x.bereichRolleMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostBereichRolleHinzufuegenMultiErfolgreichAction(result, x.bereichRolleMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBereichRolleHinzufuegenMultiFehlerAction(error, x.bereichRolleMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VerwaltenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VerwaltenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VerwaltenCommandService);
        }
        return this.service;
    }
}
